import React from 'react';

import './NotFoundPage.css';
import { useTranslation } from 'react-i18next';
export default function NotFoundPage({ message }) {
    const customGreen = "#69d945"
    const customGreenHover = "#5bc73a"
    const { t } = useTranslation();

  

    const mediaStyles = `
    @keyframes bounce {
      0%, 20%, 53%, 80%, 100% {
        transform: translate3d(0, 0, 0);
      }
      40%, 43% {
        transform: translate3d(0, -0.5rem, 0);
      }
      70% {
        transform: translate3d(0, -0.25rem, 0);
      }
      90% {
        transform: translate3d(0, -0.125rem, 0);
      }
    }

    @media (min-width: 576px) {
      .buttons-row {
        flex-direction: row !important;
      }
    }

    .primary-btn:hover {
      background-color: ${customGreenHover} !important;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(105, 217, 69, 0.3);
    }

    .outline-btn:hover {
      background-color: ${customGreen} !important;
      color: white !important;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(105, 217, 69, 0.3);
    }

    .dot-1 { animation-delay: 0s; }
    .dot-2 { animation-delay: 0.1s; }
    .dot-3 { animation-delay: 0.2s; }
  `

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: mediaStyles }} />
            <div className='container-notFound'>
                <div className='content-notFound'>
                    <div style = {{ position: "relative", marginBottom: "3rem" }}>
                        <h1 className='largeText'>404</h1>
                        <div className='iconContainer'>
                            <div className='iconCircle'>
                                <span className='iconText'>!</span>
                            </div>
                        </div>
                    </div>

                    <div style = {{ marginBottom: "3rem" }}>
                        <h2 className='title-notFound'>{t("oops!_page_not_found")}</h2>
                        <p className='subtitle-notFound'>{t("The_page_you're_looking_for_doesn't_exist_or_has_been_moved")}</p>
                    </div>
                    <div className='dotsContainer'>
                        <div  className="dot dot-1"></div>
                        <div  className="dot dot-2"></div>
                        <div  className="dot dot-3"></div>
                    </div>

                </div>
            </div>
        </>
    )

}